import { BackLink, Link, LinkType } from "../../common/components/Link";
import useMediaQuery from "../../common/hooks/useMediaQuery";
import { HOMEPAGE } from "../../utils/url/staticUrls";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../utils/screenSizes";
import { useTranslation } from "react-i18next";

import classes from "./NavigationBreadcrumbs.module.less";
import { Breadcrumbs } from "@mui/material";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import ShareButton from "../ShareButton/ShareButton";

interface Props {
  items: BreadcrumbItem[];
}

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export const NavigationBreadcrumbs = ({ items }: Props) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const { t } = useTranslation();

  if (!items?.length) {
    return null;
  }

  if (isDesktop) {
    return (
      <Breadcrumbs aria-label="breadcrumb">
        <Link href={HOMEPAGE} variant={LinkType.NAVIGATION}>
          <Icon type={IconType.Home} size={16} />
        </Link>
        {items.map((item, index) => (
          <Breadcrumb key={index} item={item} isActive={index === items.length - 1} />
        ))}
      </Breadcrumbs>
    );
  }

  // is mobile
  const visibleBreadcrumb = items[items.length - 2];
  const url = visibleBreadcrumb?.url ?? "/";
  const label = visibleBreadcrumb?.name ?? t("navigation.home");

  return <BackLink href={url}>{label}</BackLink>;
};

export function createNavigationBreadcrumbs(data: Props) {
  return (
    <div className={"scha__screen-only js-header-negative-offset"}>
      <div className={classes.root}>
        <NavigationBreadcrumbs {...data} />
        <ShareButton />
      </div>
    </div>
  );
}

const Breadcrumb = ({ item: { name, url = "" }, isActive }: { item: BreadcrumbItem; isActive?: boolean }) => {
  const { t } = useTranslation();
  // We should not try to translate the search query or designations that contain ":"
  name = name ?? "";
  const label = url.includes("search?text") ? name : name.includes(":") ? name : t(name);

  if (isActive) {
    return <span className={"js__breadcrumb-active-label"}>{label}</span>;
  }
  if (url) {
    return (
      <Link href={url} variant={LinkType.NAVIGATION}>
        {label}
      </Link>
    );
  }
  return <span>{label}</span>;
};
